<template>
    <PatientProfile
    :patientId    = "patientInfo.id"
    :name         = "patientInfo.name"
    :birth        = "patientInfo.birth"
    :age          = "patientInfo.age"
    :weight       = "patientInfo.weight"
    :lastExam     = "patientInfo.lastExam"
    :painArea     = "patientInfo.painArea"
    :showPainArea = "true"
    />
    <hr style="border:0; border-top:1.5px solid #c8c8c8; margin:12px 0;" />
    <!-- <div class="diagnosis-history-container"> -->
    <div class="exam-result-management">
        <!-- 검색/필터 영역 -->
        <!-- <Search :filter="filter" :options="options" @search="fetchExamResults"  @reset="onResetFilter"/> -->
        <div class="result-section">
            <table class="result-table">
                <colgroup>
                    <col style="width: 7%;">
                    <col style="width: 20%;">
                    <col style="width: 20%;">
                    <!-- <col style="width: 20%;"> -->
                    <col style="width: 20%;">
                    <col style="width: 8%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>no</th>
                        <th>등록일</th>
                        <th>프로토콜명</th>
                        <!-- <th>질환명</th> -->
                        <th>프로토콜 실행</th>
                        <th>실행 횟수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="diagnosisList.length === 0">
                        <td colspan="5" style="color:#9ab2ca; text-align: center;">
                            실행 이력이 없습니다.
                        </td>
                    </tr>
                    <tr v-else v-for="item in diagnosisList" :key="item.id">
                        <td>{{ item.no }}</td>
                        <td>{{ item.examDate }}</td>
                        <td>{{ item.protocol_name }}</td>
                        <!-- <td>{{ item.part }}</td> -->
                        <td>
                            <button @click="showDetail(item)" class="detail-btn">실행 하기</button>
                        </td>
                        <td>{{ item.run_count }}</td>
                    </tr>
                </tbody>
            </table>
            <pagination
                :total-items="totalCount"
                :page-size="pageSize"
                v-model="currentPage"
                @page-change="onPageChange"
            />
        </div>
    </div>
</template>
<script setup>
    defineOptions({
        meta: {
            title       : '프로토콜 실행 이력',
            segmentKey  : 'patientId',
            filter      : 'PrescriptionListFilter',
            page        : 'PrescriptionListPage',
        }
    })

    import Pagination            from "@/components/common/Pagination.vue";
    import PatientProfile        from "@/components/common/PatientProfile.vue";
    import Search                from "@/components/common/Search.vue";
    import {useRouter, useRoute} from "vue-router";
    import api, {urls}           from "@/api";
    import {computed, onMounted, reactive, ref, watch} from "vue";
    import { commonUtils }  from "@/utils/commonUtils";
    import { useAppAlert }  from '@/composables/useAppAlert'

    const { showAlert, showAlertAndMove, confirm } = useAppAlert()

    const router = useRouter()
    const route  = useRoute()

    const options = [
        {value: 'parts', label: '질환명'},
        {value: 'run', label: '실행횟수'}
    ]

    const patientInfo   = ref({})
    const diagnosisList = ref([])
    const filter = reactive({
        searchType: "all",
        searchText: "",
        startDate: "",
        endDate: "",
    })

    const currentPage = ref(Number(sessionStorage.getItem('PrescriptionListPage') || 1));
    const pageSize    = ref(10)
    const totalPages  = ref(1)
    const totalCount  = ref(0)

    function onPageChange(page) {
        fetchExamResults(page)
        currentPage.value = page
    }

    function PatientData() {
        const idFromRoute = route.params.patientId;
        api.post(urls.patientList.patientData, { id: idFromRoute })
            .then(res => {
                const data = res.data.list ? res.data.list[0] : res.data; // list 배열로 올 수도 있음

                // 응답 필드 → patientInfo 매핑
                patientInfo.value = {
                    id       : data.patient_id,
                    name     : data.name,
                    birth    : data.dob || '',
                    age      : commonUtils.calcAge(data.dob),
                    weight   : data.weight,
                    lastExam : data.created_at ? data.created_at.split('T')[0] : '',
                    painArea : data.pain_area || ''
                };
            })
            .catch(err =>{
                showAlert("환자 정보 불러오는데 실패했습니다.")
            })
    }

    const fetchExamResults = async(page = 1) => {
        const idFromRoute = route.params.patientId;

        try {
            const params = {
                startIndex  : page,
                pageRow     : pageSize.value,
                patientId   : idFromRoute,
                searchType  : filter.searchType,
                searchText  : filter.searchText?.trim() || null,
                ...(filter.startDate && { startDate: filter.startDate + " 00:00:00" }),
                ...(filter.endDate   && { endDate: filter.endDate + " 23:59:59" })
            };

            const res       = await api.post(urls.patientList.prescriptionSearch, params);
            const pageStart = (page - 1) * pageSize.value;

            diagnosisList.value = (res.data.list || []).map((item, index) => ({
                no            : pageStart + index + 1,
                id            : item.prescription_id,        // 처방 고유 ID
                patientId     : item.patient_id           ,  // 환자 id
                examDate      : item.prescribed_date ? item.prescribed_date.split("T")[0] : "",
                part          : item.pain_area || "",        // 통증 부위
                run_count     : item.count || 0,             // 실행 횟수
                protocol_name : item.protocol_name || "",
            }));

            totalCount.value  = res.data.totCnt;
            totalPages.value  = Math.ceil(totalCount.value / pageSize.value);
            currentPage.value = page;
        } catch (err) {
            diagnosisList.value = [];
            totalCount.value    = 0;
            totalPages.value    = 1;
            currentPage.value   = 1;
        }
    }

    function showDetail(item) {
        router.push({
            path: `/patientlist/prescriptionProcess/${route.params.patientId}`,
            query: { prescriptionId: item.id }
        })
    }

    const onResetFilter = () => {
        // 필터 값 초기화
        filter.searchType = "all";
        filter.searchText = "";
        filter.startDate  = "";
        filter.endDate    = "";

        // 1페이지부터 다시 데이터 조회
        // fetchExamResults(1);
    };

    watch(
        () => filter.startDate,
        (newStart, oldStart) => {
            if (newStart && filter.endDate) {
                if (new Date(newStart) > new Date(filter.endDate)) {
                    showAlert('시작일자는 종료일자보다 작거나 같아야 합니다.');
                    filter.startDate = oldStart || '';
                }
            }
        }
    )

    watch(
        () => filter.endDate,
        (newEnd, oldEnd) => {
            if (newEnd && filter.startDate) {
                if (new Date(newEnd) < new Date(filter.startDate)) {
                    showAlert('종료일자는 시작일자보다 크거나 같아야 합니다.');
                    filter.endDate = oldEnd || '';
                }
            }
        }
    )

    const filterStorageKey = 'PrescriptionListFilter';

    watch(currentPage, (newPage) => {
        sessionStorage.setItem('PrescriptionListPage', newPage);
        fetchExamResults(newPage);
    });

    let watchFilterStop = null;
    onMounted(() => {
        PatientData();  // 환자 프로필 세팅

        const savedFilterString = sessionStorage.getItem(filterStorageKey);
        if (savedFilterString) {

            const savedFilter = JSON.parse(savedFilterString);
            filter.searchType = savedFilter.searchType || "all";
            filter.searchText = savedFilter.searchText || "";
            filter.startDate  = savedFilter.startDate || "";
            filter.endDate    = savedFilter.endDate || "";

        }

        watchFilterStop = watch(filter, (newVal) => {
            sessionStorage.setItem(filterStorageKey, JSON.stringify(newVal));
        }, { deep: true });

        fetchExamResults(currentPage.value);
    })
</script>